import { Inject, Injectable, Optional, SkipSelf } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { Observable } from 'rxjs';

import { BasicDataSubService } from '../../../../shared/basic-data-management/basic-data-subservice.class';
import { ImportService } from '../../../../shared/basic-data-management/import-service.class';

import { CachedDataSurveyService } from '../../../../technical-modules/tasks/services/cached-data-survey.service';

import { SousParcTLR } from '../entities/sous-parc-tlr.entity';

@Injectable({ providedIn: 'root' })
export class SousParcService extends ImportService {
	private path: string;

	private sousParcTLRSubService!: BasicDataSubService<SousParcTLR>;

	constructor( //
		@Inject(HttpClient) httpClient: HttpClient, //
		@Inject(CachedDataSurveyService) cachedDataSurveyService: CachedDataSurveyService, //
		@Optional() @SkipSelf() previousInstance?: SousParcService //
	) {
		super(
			httpClient,
			cachedDataSurveyService,
			"sousParcs",
			"SousParc",
		);
		if (previousInstance) {
			throw new Error(
				'SousParcService is already loaded. Import it in the AppModule only');
		}
		this.path = (window as any).baseApiPath;
		let sousParcsChanged$ = this.cachedDataSurveyService.getChangeNotification("SousParc");
		this.sousParcTLRSubService = new BasicDataSubService<SousParcTLR>(httpClient, this.path + 'sousParcs?format=TLR', sousParcsChanged$);
	}

	// Methode permettant le chargement de touts les sous-parcs
	public getSousParcTLRList(): Observable<SousParcTLR[]> {
		return this.sousParcTLRSubService.getList();
	}

	// Methode permettant le chargement de tous les sous-parcs classes par id
	public getSousParcTLRMapById(): Observable<Map<number, SousParcTLR>> {
		return this.sousParcTLRSubService.getMapById();
	}

	// Methode permettant le chargement de touts les sous-parcs par leur parc 	
	public getSousParcTLRMapByParc(): Observable<Map<number, SousParcTLR[]>> {
		return this.sousParcTLRSubService.getMapByForeignKey("byParc", (sousParc:SousParcTLR) => sousParc.parcId);
	}
	public getSousParcTLRByParc(id: number): Observable<SousParcTLR[]> {
		return this.sousParcTLRSubService.getByForeignKey("byParc", (sousParc:SousParcTLR) => sousParc.parcId, id);
	}
}